import React from 'react'
import { Translate } from '../../../language'
import Button from '../../../utils/components/Button/Button'
import { PictureIcon } from '../../../assets/icons'
import './CreateStory.css'

const CreateStory = ({
    isLoadingCreateStory,
    onFileChange = () => { },
    createStory = () => { },
    refStory,
    file,
    type,
}) => {
    return (
        <div className="background-white-create-story">
            <div ref={refStory} style={{ width: 'fit-content', margin: 'auto' }}>
                <div className="content-create-story-layout">
                    {
                        isLoadingCreateStory && (
                            <div className="new-post-loaging-files">
                                Publicando...
                            </div>
                        )
                    }
                    <label>
                        <input type="file" onChange={(event) => { onFileChange(event) }} accept=".png,.jpg,.jpeg,.gif,.mp4" />
                        <div className="input-file-new-story">
                            {file ? <>
                                {type.includes('image') &&
                                    <img alt='' className="img-prev-new-story" src={file} />
                                }
                                {type.includes('video') &&
                                    <video controls className="img-prev-new-story">
                                        <source src={file}></source>
                                    </video>
                                }
                            </> : <div>
                                <PictureIcon className="icon-new-story" />
                                <div className="text-color-green">
                                  Tu historia
                                </div>
                            </div>}
                        </div>
                    </label>
                </div>
                <Button 
                disabled={!file}
                onClick={() => {createStory()}} classNameContent="content-button-create-story" text={Translate('publish', 'es')} />
            </div>
        </div>
    )
}

export default CreateStory
